export default __webpack_public_path__ + "7a8c4eade80c05448f3159c71578cb3b.svg";